import React from 'react';
import { ToolkitFeatureFlag, Tooltip } from '@cko/primitives';
import { trackEvent } from '@cko/dashboard-shared';

import { useNotifications } from '../../../../contexts/NotificationsProvider';
import { Button, UnreadDot, Wrapper } from './ReadStatusButton.styles';

export const READ_STATUS_BUTTON_UNREAD_DOT_TEST_ID = 'notifications-in-navigation-unread-dot';
const READ_STATUS_BUTTON_TEST_ID = 'notifications-in-navigation-read-button';

type Props = {
  dashboardActionType: string;
  isRead: boolean;
  notificationId: string;
  notificationType: string;
};

export const ReadStatusButton = ({
  dashboardActionType,
  isRead,
  notificationId,
  notificationType,
}: Props) => {
  const { updateNotificationReadStatus } = useNotifications();
  const handleReadStatusButtonClick = async (event: React.MouseEvent) => {
    event.stopPropagation();
    trackEvent('Click - in-dashboard notifications - read status button', {
      dashboardActionType,
      markingNotificationAs: isRead ? 'unread' : 'read',
      notificationType,
    });
    await updateNotificationReadStatus(notificationId, !isRead);
  };

  const accessibleLabel = isRead ? 'Mark as unread' : 'Mark as read';

  return (
    <Wrapper>
      <ToolkitFeatureFlag flag="v10">
        <Tooltip text={accessibleLabel}>
          <Button
            aria-label={accessibleLabel}
            data-testid={READ_STATUS_BUTTON_TEST_ID}
            onClick={handleReadStatusButtonClick}
          >
            {!isRead && <UnreadDot data-testid={READ_STATUS_BUTTON_UNREAD_DOT_TEST_ID} />}
          </Button>
        </Tooltip>
      </ToolkitFeatureFlag>
    </Wrapper>
  );
};
